import { updateBalanceMessage } from './messages/updateBalance/updateBalanceMessage';

import { createMessage, MessageController } from './index'; // ToDo: Core need to be refactored here

export const tableInfoMessage = createMessage<'tableInfo', { type: string; tableId: string }>('tableInfo', {
  headless: true,
});

export const CoreLobbyMessageController = new MessageController(
  ['lobby'],
  [
    {
      targets: ['lobby'],
      message: updateBalanceMessage,
    },
    {
      targets: ['lobby'],
      message: tableInfoMessage,
    },
  ]
);
